const privacyPolicy = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "Welcome to our AI & IT StartUp Agency! This policy outlines how we handle your data and your rights when using our platform. By using our services, you agree to these terms."
    },
    { 
        id: "data-privacy", 
        title: "2. Data Privacy", 
        content: "We collect data to improve our AI & IT services. The types of data we collect include:",
        list: [
            "User registration details",
            "Interaction data with AI tools and platforms",
            "Billing and subscription information",
            "Customer support and feedback"
        ]
    },
    { 
        id: "terms-of-service", 
        title: "3. Terms of Service", 
        content: "By using our platform, you agree to the terms of service, which govern acceptable use, licensing, user responsibilities, and limitations of liability."
    },
    { 
        id: "user-rights", 
        title: "4. User Rights", 
        content: "As a user, you have the following rights regarding your data:",
        list: [
            "Right to access and delete your personal data",
            "Right to withdraw consent for data processing",
            "Right to correct inaccuracies in your data"
        ]
    },
    { 
        id: "data-security", 
        title: "5. Data Security", 
        content: "We use industry-standard security protocols to protect your data from unauthorized access and misuse. We continually update our systems to ensure the highest level of security."
    },
    { 
        id: "cookies", 
        title: "6. Cookies", 
        content: "We use cookies to enhance user experience and track usage patterns. This helps us improve our services and provide a better platform for users."
    },
    { 
        id: "third-party", 
        title: "7. Third-Party Services", 
        content: "We integrate third-party services to provide additional functionality, such as payment processors. These services may process your data independently, and we encourage you to review their privacy policies."
    },
    { 
        id: "data-storage", 
        title: "8. Data Storage", 
        content: "Your data is securely stored using advanced encryption methods. We retain data as long as necessary to provide our services, and you may request data deletion or transfer at any time."
    },
    { 
        id: "data-transfers", 
        title: "9. Data Transfers", 
        content: "In some cases, your data may be transferred internationally for processing. We ensure compliance with applicable privacy laws to protect your data during these transfers."
    },
    { 
        id: "policy-updates", 
        title: "10. Policy Updates", 
        content: "We may update this policy from time to time. Any significant changes will be notified to you, and the latest version will always be available on this page."
    }
];

export default privacyPolicy;